// utils/enServiceMatcher.js
import { remove as removeDiacritics } from 'diacritics'; // Use 'diacritics' package

export const serviceKeywords = {
  whatsappResponder: [
    'whatsapp',
    'auto chat',
    'chatbot',
    'automatic replies',
    'automated message',
    'instant reply',
    'digital support',
    '24/7 support',
    'virtual assistant',
    'automated service',
    'chat automation',
    'instant help',
    'scheduled response',
    'artificial intelligence'
  ],

  campaignAssistant: [
    'advertising',
    'digital promotion',
    'social media campaigns',
    'paid ads',
    'facebook ads',
    'instagram ads',
    'digital outreach',
    'promotional post',
    'sales strategy',
    'customer targeting',
    'online visibility',
    'promotional content',
    'automated advertising'
  ],

  digitalCatalog: [
    'digital catalog',
    'product gallery',
    'online inventory',
    'price list',
    'visual collection',
    'online presentation',
    'virtual display',
    'digital showcase',
    'digital menu',
    'available services',
    'show catalog',
    'view products'
  ],

  orderForm: [
    'online orders',
    'order form',
    'online ordering',
    'quick order',
    'shopping cart',
    'product request',
    'digital checkout',
    'direct purchase',
    'product basket',
    'send order',
    'purchase order'
  ],

  onlinePayments: [
    'online payments',
    'digital charges',
    'payment gateway',
    'accept cards',
    'payment link',
    'electronic transfer',
    'card payment',
    'payment url',
    'digital finances',
    'payment method'
  ],

  crmLite: [
    'crm lite',
    'customer management',
    'sales tracking',
    'contact registration',
    'conversation history',
    'note messages',
    'customer profile',
    'client status',
    'organize data',
    'control panel',
    'visual summary'
  ],

  qrFlyers: [
    'qr flyers',
    'qr code',
    'digital brochures',
    'scannable code',
    'printed promotional material',
    'physical promotion',
    'printed with qr code',
    'qr design',
    'promotional stationery',
    'qr campaign'
  ]
};

export function matchServicesFromAI(text) {
  const normalizedText = removeDiacritics(text.toLowerCase());
  // This ensures 'whatsappResponder' is always present and unique
  const matchedSet = new Set(['whatsappResponder']);

  for (const [id, keywords] of Object.entries(serviceKeywords)) {
    for (const keyword of keywords) {
      const normalizedKeyword = removeDiacritics(keyword.toLowerCase());

      // Use a word boundary regex to match full words
      const pattern = new RegExp(`\\b${normalizedKeyword}\\b`, 'i');

      if (pattern.test(normalizedText)) {
        matchedSet.add(id);
        break; // Avoid duplicates
      }
    }
  }

  return Array.from(matchedSet);
}